<template>

    <section class="help-page">
        <div class="panel" v-if="page">
            <div class="panel-heading"><h2>{{page.title}}</h2></div>
            <div class="panel-body help-text">
                <div v-html="$options.filters.linkify(page.text)"></div>           
            </div>
        </div>

    </section>

</template>
    


<script>

import support from '../services/support';
import help from './widgets/Help.vue';

export default {

    data() {
        return {
            page: null
        }
    },
    components: {
        help
    },
    mounted() {
        this.getHelp();
    },
    watch: {
        '$route.params.slug': function() {
            this.getHelp();
        }
    },
    methods: {
        getHelp() {
            var self = this;
            self.$store.dispatch('toggle',{type:'loading', boolean: true});
            support.getHelpPage(this, this.$route.params.slug.toLowerCase()).then(function(response) {
                self.page = response.data.page;
                self.$store.dispatch('toggle',{type:'loading', boolean: false});
            });
        }
    }
}
</script>


<style lang="scss" scoped>
.panel-body {
    padding:1rem;

}


</style>

<style lang="scss">
.help-text ul {
    padding-left:1.4rem;
    li {
        list-style-type: disc;
    }
}

</style>


// WEBPACK FOOTER //
// HelpPage.vue?7783e2c1